import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { CustomersComponent } from "./customers.component";
import { CustomerFormComponent } from "./customer-form/customer-form.component";
import { ManageCustomerComponent } from "./manage-customer/manage-customer.component";
import { ManageCspDetailsComponent } from "../manage-subscriptions/manage-cspdetails/manage-cspdetails.component";
import { EditEndUserDetailComponent } from "../manage-subscriptions/manage-cspdetails/edit-end-user-detail/edit-end-user-detail.component";
import { EditPaymentDetailComponent } from "../manage-subscriptions/manage-cspdetails/edit-payment-detail/edit-payment-detail.component";
import { AddDigitalWalletComponent } from "../manage-subscriptions/shared/add-digital-wallet/add-digital-wallet.component";
import { AddSubscriptionsComponent } from "../manage-subscriptions/manage-cspdetails/add-subscriptions/add-subscriptions.component";
import { ConfigurePortalManagement } from "../manage-subscriptions/manage-cspdetails/configure-portal-management/configure-portal-management.component";
import { AddProductsComponent } from "../manage-subscriptions/manage-cspdetails/add-product/add-product.component";
import { ConfirmProductsComponent } from "../manage-subscriptions/manage-cspdetails/add-product/confirm-product/confirm-product.component";
import { AddAddonComponent } from "../manage-subscriptions/manage-cspdetails/add-addon/add-addon.component";
import { ManageLicenseSubscriptionComponent } from "../manage-subscriptions/manage-cspdetails/manage-license-subscription/manage-license-subscription.component";
import { ConfirmUpgradeComponent } from "../manage-subscriptions/manage-cspdetails/manage-license-subscription/confirm-upgrade/confirm-upgrade.component";
import { ConfirmRenewalComponent } from "../manage-subscriptions/manage-cspdetails/manage-license-subscription/confirm-renewal/confirm-renewal.component";
import { ManageReservedInstanceComponent } from "../manage-subscriptions/manage-cspdetails/manage-reserved-instance/manage-reserved-instance.component";
import { ManageAzureSubscriptionComponent } from "../manage-subscriptions/manage-cspdetails/manage-azure-subscription/manage-azure-subscription.component";
import { BudgetAndAlertsDetailsComponent } from "../manage-subscriptions/manage-cspdetails/manage-azure-subscription/budget-and-alerts/budget-and-alerts-details/budget-and-alerts-details.component";
import { BudgetAndAlertsEditComponent } from "../manage-subscriptions/manage-cspdetails/manage-azure-subscription/budget-and-alerts/budget-and-alerts-edit/budget-and-alerts-edit.component";
import { AddPerpetualComponent } from "../manage-subscriptions/manage-cspdetails/add-perpetual/add-perpetual.component";
import { BudgetAndAlertsComponent } from "../manage-subscriptions/manage-cspdetails/manage-azure-subscription/budget-and-alerts/budget-and-alerts.component";
import { AddAzureRiComponent } from "../manage-subscriptions/manage-cspdetails/add-azure-ri/add-azure-ri.component";
import { SelectAzureRiComponent } from "../manage-subscriptions/manage-cspdetails/add-azure-ri/select-azure-ri/select-azure-ri.component";
import { AddSoftwareComponent } from "../manage-subscriptions/manage-cspdetails/add-software/add-software.component";
import { EnrollProgramComponent } from "./enroll-program/enroll-program.component";
import { AssociateExistingEndUserComponent } from "../manage-subscriptions/manage-annuities/associate-existing-end-user/associate-existing-end-user.component";
import { CreateEndUserComponent } from "../manage-subscriptions/manage-annuities/create-end-user/create-end-user.component";


const routes: Routes = [
  {
    path: "customers",
    component: CustomersComponent,
    data: {
      breadcrumb: "Customers",
    },
    children: [
      {
        path: "customer-form",
        component: CustomerFormComponent,
        data: {
          breadcrumb: "New Customer",
        }
      },
      {
        path: ":customerId",
        component: ManageCustomerComponent,
        data: {
          breadcrumb: "customerId",
        },
        children: [
          {
            path: "edit-customer",
            component: CustomerFormComponent,
            data: {
              breadcrumb: "Edit Customer",
            }
          },
          {
            path: "enroll-program",
            component: EnrollProgramComponent,
            data: {
              breadcrumb: "Enroll Program",
            },
            children: [
              {
                path: "associateExistingEndUser",
                component: AssociateExistingEndUserComponent,
                data: {
                  breadcrumb: "Associate Existing End User",
                },
              },
              {
                path: "createTenant",
                component: CreateEndUserComponent,
                data: {
                  breadcrumb: "Create New Tenant",
                },
              },
            ]
          },
          {
            path: "CSP/:tenantId",
            component: ManageCspDetailsComponent,
            data: {
              breadcrumb: "tenantId",
            },
            children: [
              {
                path: "EditEndUser",
                component: EditEndUserDetailComponent,
                data: {
                  breadcrumb: "Edit Tenant Details",
                },
              },
              {
                path: "EditPaymentDetails",
                component: EditPaymentDetailComponent,
                data: {
                  breadcrumb: "Edit Payment Details",
                },
                children: [
                  {
                    path: "CreateDigitalWallet",
                    component: AddDigitalWalletComponent,
                    data: {
                      breadcrumb: "Digital Wallet",
                    },
                  }
                ]
              },
              {
                path: "AddSubscriptions",
                component: AddSubscriptionsComponent,
                data: {
                  breadcrumb: "Add Subscriptions",
                },
              },
              //configure portal management
              {
                path: "ConfigurePortalManagement",
                component: ConfigurePortalManagement,
                data: {
                  breadcrumb: "Configure End User Portal",
                },
              },
              //add product list
              {
                path: "AddProducts/:productType",
                component: AddProductsComponent,
                data: {
                  breadcrumb: "Add Products",
                },
                children: [
                  {
                    path: "ConfirmProducts",
                    component: ConfirmProductsComponent,
                    data: {
                      breadcrumb: "Confirm Products",
                    },
                  },
                ],
              },
              {
                path: "AddAddon/:stockCode/:subscriptionId",
                component: AddAddonComponent,
                data: {
                  breadcrumb: "Add Addon",
                },
              },
              // upgrade subscription
              {
                path: "ManageLicenseSubscriotion/:menuTitle",
                component: ManageLicenseSubscriptionComponent,
                data: {
                  breadcrumb: "Manage Subscription",
                },
                children: [
                  {
                    path:'ConfirmUpgrade/:catalogItemId',
                    component: ConfirmUpgradeComponent,
                    data: {
                      breadcrumb: "Confirm Upgrade",
                    },
                  },
                  {
                    path:'ConfirmRenewal/:catalogItemId',
                    component: ConfirmRenewalComponent,
                    data: {
                      breadcrumb: "Confirm Rnewal",
                    },
                  }
                ]
              },
              {
                path: "ManageReservedInstance",
                component: ManageReservedInstanceComponent,
                data: {
                  breadcrumb: "Manage Reserved Instance",
                }
              },
              {
                path: "ManageAzureSubscription/:menuTitle/:scopeForBudget",
                component: ManageAzureSubscriptionComponent,
                data: {
                  breadcrumb: "Manage Azure Subscription",
                },
                children: [
                  {
                    path:'ConfirmUpgrade/:catalogItemId',
                    component: ConfirmUpgradeComponent,
                    data: {
                      breadcrumb: "Confirm Upgrade",
                    },
                  },
                  {
                    path: "BudgetAlertDetails/:budgetName",
                    component: BudgetAndAlertsDetailsComponent,
                    data: {
                      breadcrumb: "budgetName"
                    },
                  },
                  {
                    path: "BudgetAlertEdit/:budgetName",
                    component: BudgetAndAlertsEditComponent,
                    data: {
                      breadcrumb: "budgetName"
                    },
                  },
                  {
                    path: "createBudget/:scopeId",
                    component: BudgetAndAlertsEditComponent,
                    data: {
                      breadcrumb: "Create Budget"
                    },
                  }
                ]
              },
              {
                path: "Budget&Alerts",
                component: BudgetAndAlertsComponent,
                data: {
                  breadcrumb: "Budget & Alerts",
                }
              },
              {
                path: "AddPerpetual",
                component: AddPerpetualComponent,
                data: {
                  breadcrumb: "Add Perpetual",
                },
              },
              {
                path: "AddAzureRi",
                component: AddAzureRiComponent,
                data: {
                  breadcrumb: "Add AzureRi",
                },
                children: [
                  {
                    path: "SelectAzureRi/:catalogueId",
                    component: SelectAzureRiComponent,
                    data: {
                      breadcrumb: "Select Azure Ri",
                    },
                  },
                ],
              },
              {
                path: "AddSoftware",
                component: AddSoftwareComponent,
                data: {
                  breadcrumb: "Add Software",
                },
              },
            ],
          }
        ]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CustomersRoutingModule { }
